import React, { useRef, useState } from 'react';
import { api } from '../../../lib/api';
import { toast } from 'sonner';
import { Modal, L } from './ui';

/* ---------------- Digital signing (typed + drawn) ---------------- */

function SignModal({ emp, onClose, onSigned }) {
  const [name, setName] = useState('');
  const [role, setRole] = useState('employee');
  const [typed, setTyped] = useState('');
  const canvasRef = React.useRef(null);
  const drawing = React.useRef(false);
  const [hasDrawn, setHasDrawn] = useState(false);

  const pos = (e) => {
    const c = canvasRef.current, r = c.getBoundingClientRect();
    const t = e.touches?.[0] || e;
    return { x: (t.clientX - r.left) * (c.width / r.width), y: (t.clientY - r.top) * (c.height / r.height) };
  };
  const start = (e) => { drawing.current = true; const c = canvasRef.current.getContext('2d'); const p = pos(e); c.beginPath(); c.moveTo(p.x, p.y); };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const c = canvasRef.current.getContext('2d'); const p = pos(e);
    c.lineWidth = 2; c.lineCap = 'round'; c.strokeStyle = '#1a1a1a';
    c.lineTo(p.x, p.y); c.stroke(); setHasDrawn(true);
  };
  const end = () => { drawing.current = false; };
  const clear = () => { const c = canvasRef.current; c.getContext('2d').clearRect(0, 0, c.width, c.height); setHasDrawn(false); };

  const submit = async () => {
    if (!name.trim()) { toast.error('Enter the signer name.'); return; }
    if (!hasDrawn && !typed.trim()) { toast.error('Draw or type a signature.'); return; }
    try {
      await api.post(`/hr/employees/${emp.employee_id}/sign`, {
        signer_name: name, signer_role: role,
        signature_data_url: hasDrawn ? canvasRef.current.toDataURL('image/png') : null,
        typed_signature: typed.trim() || null,
      });
      toast.success('Signature recorded.');
      onSigned();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Signing failed');
    }
  };

  return (
    <Modal onClose={onClose}>
      <h3 className="font-heading font-bold text-lg mb-3">Digital signature</h3>
      <div className="grid md:grid-cols-2 gap-3 mb-3">
        <L label="Signer full name *"><input className="input" value={name} onChange={e=>setName(e.target.value)} data-testid="sign-name"/></L>
        <L label="Signing as">
          <select className="input" value={role} onChange={e=>setRole(e.target.value)} data-testid="sign-role">
            <option value="employee">Employee / Professional</option>
            <option value="clinic">Clinic representative</option>
          </select>
        </L>
      </div>
      <L label="Draw signature (mouse or touch)">
        <canvas ref={canvasRef} width={560} height={140}
                className="w-full border border-soft rounded-md bg-white touch-none cursor-crosshair"
                onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
                onTouchStart={start} onTouchMove={move} onTouchEnd={end}
                data-testid="sign-canvas"/>
      </L>
      <div className="flex justify-between items-center mt-1 mb-3">
        <button className="text-xs text-fg-muted underline" onClick={clear}>Clear drawing</button>
        <span className="text-xs text-fg-muted">…or type below (non-drawn digital signature)</span>
      </div>
      <L label="Typed signature"><input className="input font-serif italic" value={typed} onChange={e=>setTyped(e.target.value)} placeholder="Type full legal name" data-testid="sign-typed"/></L>
      <div className="flex gap-2 justify-end mt-4">
        <button className="btn-secondary" onClick={onClose}>Cancel</button>
        <button className="btn-primary" onClick={submit} data-testid="sign-submit">Record signature</button>
      </div>
    </Modal>
  );
}

export { SignModal };
